;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.Invite = Backbone.Model.extend({
		url: function() {
			return this.methodUrl;
		},

		isNew: function() {
			return true;
		},

		defaults: {
			first_name: '',
			email:      ''
		},

		validate: function() {
			return this.get('first_name').length && this.get('email').length;
		}
	});

}(window, APP, Backbone, Marionette, $, _));